export default __webpack_public_path__ + "static/media/water.inline.df59a1eb.svg";